import { render } from "./SettingSensorPopup.vue?vue&type=template&id=4fc4ae4c"
import script from "./SettingSensorPopup.vue?vue&type=script&lang=js"
export * from "./SettingSensorPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__